module.exports = __webpack_public_path__ + "static/media/Artist-Website_Artists-Arrow_Artists-Arrow.64ade3ac.svg";